import React, { useEffect, useState, useRef } from 'react';
import { BarChart3Icon, InfoIcon } from 'lucide-react';
export function ImpactEstimation() {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!showTooltip) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (tooltipRef.current && !tooltipRef.current.contains(e.target as Node) && buttonRef.current && !buttonRef.current.contains(e.target as Node)) {
        setShowTooltip(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showTooltip]);
  return <div className="mt-4 pt-4 border-t border-slate-100" data-id="element-1984" data-mp="tae8p60u2p8d">
      <div className="flex items-center gap-2 mb-3" data-id="element-1985" data-mp="y8fqzoqfqkis">
        <BarChart3Icon className="w-4 h-4 text-slate-400" data-id="element-1986" data-mp="128zkmibsv606" />
        <h4 className="text-xs font-bold uppercase tracking-wider text-slate-500 font-caption" data-id="element-1987" data-mp="129j1rwtmlqd5">
          Estimation d'impact
        </h4>
        <div className="relative ml-auto" data-id="element-1988" data-mp="39wqea038j842">
          <button ref={buttonRef} onClick={() => setShowTooltip(!showTooltip)} onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} className="flex items-center justify-center w-4 h-4 rounded-full text-slate-400 hover:text-slate-500 transition-colors focus:outline-none" aria-label="Informations sur les estimations" data-id="element-1989" data-mp="39vp4dyxygrnx">
            <InfoIcon className="w-3.5 h-3.5" data-id="element-1990" data-mp="3sn833tky5jk5" />
          </button>
          {showTooltip && <div ref={tooltipRef} className="absolute right-0 bottom-full mb-2 w-56 px-3 py-2 bg-[#0F172A] text-white text-[11px] leading-relaxed rounded-lg shadow-lg z-50 font-body" data-id="element-1991" data-mp="3spb1b0w96izy">
              Ces indicateurs représentent des moyennes observées sur le marché.
              Vos performances peuvent varier selon votre audience et votre
              stratégie.
              <div className="absolute right-3 top-full w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-[#0F172A]" data-id="element-1992" data-mp="ffwl8pkok5hl"></div>
            </div>}
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2" data-id="element-1993" data-mp="2embrdyc9gt7v">
        <div className="flex flex-col" data-id="element-1994" data-mp="1zyqp26n7my10">
          <span className="text-[10px] text-slate-400 font-medium uppercase tracking-wide" data-id="element-1995" data-mp="1zxxnrl70t0q9">
            Push
          </span>
          <span className="text-sm font-semibold text-slate-600 font-caption" data-id="element-1996" data-mp="24vz8sbo0ba4d">
            78%{' '}
            <span className="text-[10px] font-normal text-slate-400" data-id="element-1997" data-mp="1qwr6h9wjrlvy">ouv.</span>
          </span>
        </div>
        <div className="flex flex-col" data-id="element-1998" data-mp="1uxjgi5d8tuta">
          <span className="text-[10px] text-slate-400 font-medium uppercase tracking-wide" data-id="element-1999" data-mp="1h0o2rzm1rf6w">
            Email
          </span>
          <span className="text-sm font-semibold text-slate-600 font-caption" data-id="element-2000" data-mp="1lzr0t03m0l5d">
            32%{' '}
            <span className="text-[10px] font-normal text-slate-400" data-id="element-2001" data-mp="3bef9orczrkyn">ouv.</span>
          </span>
        </div>
        <div className="flex flex-col" data-id="element-2002" data-mp="3gc7cwhj36ti5">
          <span className="text-[10px] text-slate-400 font-medium uppercase tracking-wide" data-id="element-2003" data-mp="14pdl0vjhu9x3">
            SMS
          </span>
          <span className="text-sm font-semibold text-slate-600 font-caption" data-id="element-2004" data-mp="zrbtdm8052a0">
            91%{' '}
            <span className="text-[10px] font-normal text-slate-400" data-id="element-2005" data-mp="1eghzlu59bsre">ouv.</span>
          </span>
        </div>
      </div>
    </div>;
}